<template>
    <div id="breadcrumb" ref="breadcrumbRoot" @click="closeTenantDropdown($event)">

        <transition name="curtain">
            <div class="curtain" v-if="TenantDropDownVisible"></div>
        </transition>
        <img src="../../public/icons/homeV2.svg" class="breadcrumb-homeV2-svg" style="cursor:pointer;"
            @click="goHome">

        <transition-group name="fso" tag="span">
            <span v-for="(item,i) in BreadCrumbItems" :key="item.payload.id" :style="{'--i':i}" v-show="getTranslation(item.name)">
                <img class="arrowLeft breadcrumb-svg">
                <span class="breadcrumb-button" @click="BreadcrumbItem_Click(item)">{{ getTranslation(item.name) }}</span>
            </span>
        </transition-group>

        <div id="tenant_v2" ref="tenantContainerV2" v-if="Tenant!=null" @click.stop="toggleTenantDropDown()" class="no-outline" tabindex="1">
            <div class="tenant-divider"></div>
            <div class="headerbtnmain"> 
            <div class="tenant-section" :title="Tenant.name ?? ''" :style="{ 
                '--line-color': getTenantIconColor() !== DefaultTenantColor ? getTenantIconColor() : 'transparent' }">              
            <CloudIcon 
                    class="cloud-icon" 
                    :color="getTenantIconColor()" 
                    />
                <span class="tenant-name">
                    {{""+FormatTenantName(Tenant.name, Tenant.caption)}}
                </span>
                &nbsp; 
                <f-icon-button icon="chevrondown" class="theme-svg" />
                </div>
            </div>
            <transition name="headermodal">
                <div class="tenantmodal" v-show="TenantDropDownVisible">
                    <div class="headerbtn" @click="switchTenant">
                        <img src="../../public/icons/header/cloud_new.svg" style="margin-right: 8px;"/> &nbsp;{{Localizer.Localize("Header_Switch_Tenant")}}
                    </div>
                    <div class="dividing-line"></div>
                    <div class="headerbtn" @click.stop="openColorPickerMenu($event)">
                        <img src="../../public/icons/header/color-fill.svg" style="margin-right: 8px;"/> &nbsp;{{Localizer.Localize("Header_Change_Color")}}
                    </div>
                </div>
            </transition>
            <div v-if="showColorPickerMenu" :style="colorPickerMenuStyle">
                <TenantColorPickerContextMenu
                    :current-color="getTenantIconColor()"
                    @colorSelected="onColorSelected"
                    @resetColor="onResetColor"
                    @close="showColorPickerMenu = false"
                />
            </div>
        </div>

        <div class="languages" v-if="this.Tenant" :title="this.getLanguageTitleText()">
            <input type="file" id="loadLanguageFile" style="display: none" @change="LoadCustomLanguage" accept="text/json" />
            <f-dropdown :trigger="['click']" class="no-outline">
                <f-icon-button icon="translation" color="#242D48 " />
                <template v-slot:overlay>
                    <f-menu :items="localeLangs()" @click="setOverrideLang" v-model:value="selLang" class="anaplanCustom">
                        <template v-slot:item="{ item }">
                            <div :title="Localizer.Localize(item.name.length == 2 ? 'lng_' + item.name.toUpperCase() : '')">
                                {{ item.caption }} <span v-if="item.name.length == 2">({{ item.name.toUpperCase() }})</span>
                            </div>
                        </template>
                    </f-menu>
                </template>
            </f-dropdown>
        </div>

        <div class="whatsnew" @click="OpenReleaseNotes()" v-if="!hideWhatsNew">
            <img v-if="newVersionUpdatesAvailable" src="../../public/icons/dialog/whatsnew_notification.svg" />
            <img v-else src="../../public/icons/dialog/re_whatsnew.svg" />
        </div>

        <WhatsNewDialog v-if="showReleaseNotes==true" @close="showReleaseNotes=false" :ishtml="true" :size="'lg'">
        </WhatsNewDialog>

    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
    import RouteNames from '../routing/RouteNames';
    import * as api from '../api/ApiClient';
    import * as base from "../api/ApiClientBase";
    import { Localizer } from '@/api/Localizer';
    import * as uiIntegration from '@/api/FluenceIntegration';
    import { AuthClient } from "../api/ApiClientBase";
    import WhatsNewDialog from "../components/helpers/WhatsNewDialog.vue";
    import TenantColorPickerContextMenu from "./modals/TenantColorPickerContextMenu.vue";
    import PubSub from 'pubsub-js';
    import languages from "../../public/locales/languages.json";
    import ModuleAuthHelper from '@/api/ModuleAuthHelper';
    import { COLOR_PALETTE, DEFAULT_TENANT_COLOR, ColorProp } from '../constants/TenantSwitcherColors';
    import CloudIcon from "./icons/CloudIcon.vue";
    import { isFeatureFlagEnabled } from '@/services/featureFlagService';

    class BreadcrumbItem {

        public name: string;
        public location: any;
        public payload: any | null;        

        constructor(name: string, location: any, payload: api.FileSystemObjectContent | string) {
            this.name = name;
            this.location = location;
            if (typeof payload === 'object') {
                this.payload = payload;
            }
            else {
                this.payload = { id: payload };
            }
        }
    }

    @Component({components:{AuthClient, Watch, WhatsNewDialog, TenantColorPickerContextMenu, CloudIcon}})
    export default class Breadcrumb extends Vue {
        private Localizer = new Localizer(this.$store);
        private isV2FlagEnabled: any = false;
        private isCopyDataEnhancementsEnabled: boolean = false;

        get Tenant(): api.Tenant { return this.$store.state.security.Tenant; }
        get UserData(): api.ExtendedUserData { return this.$store.state.security.UserData; }

        private selLang: string | undefined = localStorage.getItem("UserLocaleOverride") ? localStorage.getItem("UserLocaleOverride")! : 'en';
        TranslationtDropDownVisible: boolean = false;
        cachedLocaleLangs: any | null = null;
        toggleTranslationtDropDown(visible: boolean) {
            this.TranslationtDropDownVisible = visible;
        }

        getTranslation(toTranslate : string) : string {
            return this.Localizer.Localize(toTranslate);
        }

        getLanguageTitleText(): string {
            let cookieOverride = localStorage.getItem("UserLocaleOverride") ? " (" + localStorage.getItem("UserLocaleOverride")?.toUpperCase()! + ")" : '';
            return this.Localizer.Localize('Header_Select_Language') + cookieOverride;
        }

        get FeatureFlagLocalesDebug(): boolean {
            let ud = this.$store.state.security.UserData as api.ExtendedUserData;
            if (ud != null && ud.featureFlags != null) {
                for (let i = 0; i < ud.featureFlags!.length; i++) {
                    if (ud.featureFlags[i] == "LocalesDebug")
                        return true;
                }
            }
            return false;
        }

        get ModuleSecurityAccess(): api.Module[] | null {
            return this.$store.state.security.ModuleSecurity;
        }

        get UserCanAccessModels(): boolean {
            return this.ModuleSecurityAccess != null
                && ModuleAuthHelper.ModuleIdInAccess(this.ModuleSecurityAccess,api.ModuleAccess.MetadataManagementModelManagementManage);
        }

        get UserCanAccessModelSecurity(): boolean {
            return this.ModuleSecurityAccess != null
                && ModuleAuthHelper.ModuleIdInAccess(this.ModuleSecurityAccess,api.ModuleAccess.SecurityMetadataSecurityAssign);
        }

        get UserCanAccessHomepages(): boolean {
            return this.ModuleSecurityAccess != null
                && ModuleAuthHelper.ModuleIdInAccess(this.ModuleSecurityAccess,api.ModuleAccess.HomepagesHomepageManagementManage);
        }

        // eslint-disable-next-line complexity
        get BreadCrumbItems(): BreadcrumbItem[] {
            const result: BreadcrumbItem[] = [];
            const route = this.$route.name;

            if (route == RouteNames.ExplorerRoute) {
                const selectedFso = this.$store.state.explorer.SelectedFso as api.FileSystemObjectContent | null;
                if (selectedFso != null && selectedFso.id != null) {
                    const hierarchy = this.$store.getters['explorer/getFsoHierarchyById']
                        (selectedFso.id) as api.FileSystemObjectContent[] | null;

                    if (hierarchy != null) {
                        for (let i = 0; i < hierarchy.length; i++) {
                            const myFso = hierarchy[i];
                            result.push(new BreadcrumbItem(
                                i == 0 ? this.Localizer.Localize('Breadcrumb_Explorer') : myFso.name!,
                                { name: route, query: { selectedFso: myFso.id.toString() } },
                                hierarchy[i]
                            ));
                        }
                    }
                }
            }

            else if (route == RouteNames.SecurityManagementUsersRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security'),
                    { name: RouteNames.SecurityManagementRoute },
                    RouteNames.SecurityManagementRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security_Users'),
                    { name: route },
                    RouteNames.SecurityManagementUsersRoute
                ));
            }

            else if (route == RouteNames.MatchingUI) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Sidebar_Matching'),
                    { name: RouteNames.MatchingUI },
                    RouteNames.MatchingUI
                ));

                result.push(new BreadcrumbItem(
                    this.$store.getters['matching/matchGroup'],
                    { name: RouteNames.MatchingUI },
                    this.$store.getters['matching/matchGroup']
                ));
            }

            else if (route == RouteNames.SecurityManagementRolesRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security'),
                    { name: RouteNames.SecurityManagementRoute },
                    RouteNames.SecurityManagementRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security_Roles'),
                    { name: route },
                    RouteNames.SecurityManagementRolesRoute
                ));
            }
            else if (route == RouteNames.SecurityManagementModulesRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security'),
                    { name: RouteNames.SecurityManagementRoute },
                    RouteNames.SecurityManagementRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security_Modules'),
                    { name: route },
                    RouteNames.SecurityManagementModulesRoute
                ));
            }
            else if (route == RouteNames.LogManagementAuditTrailRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Logs'),
                    { name: RouteNames.LogsRoute },
                    RouteNames.LogsRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security_Audit_Trail'),
                    { name: route },
                    RouteNames.LogManagementAuditTrailRoute
                ));
            }
            else if (route == RouteNames.AuditRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Audit'),
                    { name: route },
                    RouteNames.AuditRoute
                ));
            }
            else if (route == RouteNames.LogManagementEtlLogsRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Logs'),
                    { name: RouteNames.LogsRoute },
                    RouteNames.LogsRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security_Import_DrillBack'),
                    { name: route },
                    RouteNames.LogManagementEtlLogsRoute
                ));
            }
            else if (route == RouteNames.NotificationRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Logs'),
                    { name: RouteNames.LogsRoute },
                    RouteNames.LogsRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Notifications_Session_Log'),
                    { name: route },
                    RouteNames.NotificationRoute
                ));
            }
            else if (route == RouteNames.AboutSystemInformationRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_About'),
                    { name: RouteNames.AboutRoute },
                    RouteNames.AboutRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('About_System_Information'),
                    { name: route },
                    RouteNames.AboutSystemInformationRoute
                ));
            }
            else if (route == RouteNames.SecurityManagementUserReportsRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security'),
                    { name: RouteNames.SecurityManagementRoute },
                    RouteNames.SecurityManagementRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security_User_Reports'),
                    { name: route },
                    RouteNames.SecurityManagementUserReportsRoute
                ));
            }
            else if (route == RouteNames.SecurityManagementProfileRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security'),
                    { name: RouteNames.SecurityManagementRoute },
                    RouteNames.SecurityManagementRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Security_Profile'),
                    { name: route },
                    RouteNames.SecurityManagementProfileRoute
                ));
            }
            else if (route == RouteNames.DataMapsRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('DataMaps_Title'),
                    { name: route },
                    RouteNames.DataMapsRoute
                ));
            }
            else if (route == RouteNames.MemberMappingsViewRoute || route == RouteNames.MemberMappingsMultiDimViewRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('DataMaps_Title'),
                    { name: RouteNames.DataMapsRoute },
                    RouteNames.DataMapsRoute
                ));
                const selectedMap = this.$store.state.etl.SelectedDataMap as api.DataMapInfo | null;
                if (selectedMap != null) {
                    result.push(new BreadcrumbItem(
                        selectedMap.sourceName!,
                        { name: route, query: { selectedMap: selectedMap.sourceName! } },
                        selectedMap.sourceName!
                    ));
                }
            }
            else if (route == RouteNames.MemberMappingsAiViewRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('DataMaps_Title'),
                    { name: RouteNames.DataMapsRoute },
                    RouteNames.DataMapsRoute
                ));
                const selectedMap = this.$store.state.etl.SelectedDataMap as api.DataMapInfo | null;
                if (selectedMap != null) {
                    result.push(new BreadcrumbItem(
                        selectedMap.sourceName!,
                        { name: RouteNames.MemberMappingsViewRoute, query: { name: selectedMap.sourceName! } },
                        selectedMap.sourceName!
                    ));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('MemberMappingsAiAssisted_Title'),
                        { name: RouteNames.MemberMappingsAiViewRoute, query: { name: selectedMap.sourceName! } },
                        RouteNames.MemberMappingsAiViewRoute
                    ));
                }
            }
            else if (route == RouteNames.DataModelMappingsRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('DataImportDefinitions_Title'),
                    { name: route },
                    RouteNames.DataModelMappingsRoute
                ));
            }
            else if (route == RouteNames.ClearDataViewRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('DataImportDefinitions_Title'),
                    { name: RouteNames.DataModelMappingsRoute },
                    RouteNames.DataModelMappingsRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('ClearDataSettings_Title'),
                    { name: route },
                    RouteNames.ClearDataViewRoute
                ));
            }
            else if (route == RouteNames.FieldMappingsViewRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('DataImportDefinitions_Title'),
                    { name: RouteNames.DataModelMappingsRoute },
                    RouteNames.DataModelMappingsRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('FieldMappingView_FieldMapping'),
                    { name: route },
                    RouteNames.FieldMappingsViewRoute
                ));
            }
            else if (route == RouteNames.DataConnectionStringsRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Connection_Strings'),
                    { name: route },
                    RouteNames.DataConnectionStringsRoute
                ));
            }
            else if (route == RouteNames.DataStagingTableRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Staging_Tables'),
                    { name: route },
                    RouteNames.DataStagingTableRoute
                ));
            }
            else if (route == RouteNames.DataStagingTableEditRoute) {
                const selectedTable = this.$store.state.etl.SelectedStagingTable as api.StagingTableInfo | null;
                const tableName = selectedTable ? selectedTable.tableName : null;
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Staging_Tables'),
                    { name: RouteNames.DataStagingTableRoute },
                    RouteNames.DataStagingTableRoute
                ));
                result.push(new BreadcrumbItem(
                    tableName ? tableName : this.Localizer.Localize('StagingTableDetails_New_Table'),
                    { name: route, query: { name: tableName } },
                    RouteNames.DataStagingTableEditRoute
                ));
            }
            else if (route == RouteNames.DataThemesRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Themes_Title'),
                    { name: route },
                    RouteNames.DataThemesRoute
                ));
            }
            else if (route == RouteNames.DataThemeDetailsRoute) {
                const selectedTheme = this.$store.state.theme.ThemeDetails;
                const themeName = selectedTheme ? selectedTheme.themeName : null;
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Themes_Title'),
                    { name: RouteNames.DataThemesRoute },
                    RouteNames.DataThemesRoute
                ));
                result.push(new BreadcrumbItem(
                    themeName ? themeName : this.Localizer.Localize('Theme_Details_New_Theme'),
                    { name: route, query: { name: themeName } },
                    RouteNames.DataThemeDetailsRoute
                ));
            }
            else if (route == RouteNames.DataJournalsRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Configure'),
                    { name: RouteNames.DataRoute },
                    RouteNames.DataRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Homepages_JournalConfig'),
                    { name: route },
                    RouteNames.DataJournalsRoute
                ));
                const selectedJournal = this.$store.state.etl.SelectedJournalConfig as api.JournalDefinition | null;
                if (selectedJournal != null) {
                    result.push(new BreadcrumbItem(
                        selectedJournal.name ?? '',
                        { name: route, query: { name: selectedJournal.name } },
                        selectedJournal.name ?? ''
                    ));
                }
            }

            else if (route == RouteNames.ModelViewRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute
                    ));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Models'),
                        { name: RouteNames.ModelViewRoute },
                        RouteNames.ModelViewRoute
                    ));
                }
            }
            else if (route == RouteNames.DimensionViewRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Dimensions'),
                        { name: RouteNames.DimensionViewRoute },
                        RouteNames.DimensionViewRoute
                    ));
                }
            }
            else if (route == RouteNames.ModelViewsViewRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute
                    ));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Model_ModelViews'),
                        { name: RouteNames.ModelViewsViewRoute },
                        RouteNames.ModelViewsViewRoute
                    ));
                }
            }
            else if (route == RouteNames.ModelSubsetsRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute
                    ));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Model_Subsets'),
                        { name: RouteNames.ModelSubsetsRoute },
                        RouteNames.ModelSubsetsRoute
                    ));
                }
            }
            else if (route == RouteNames.ModelListsRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute
                    ));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Model_Lists'),
                        { name: RouteNames.ModelListsRoute },
                        RouteNames.ModelListsRoute
                    ));
                }
            }
            else if (route == RouteNames.ModelDataMappingsRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Metadata'),
                    { name: RouteNames.ModelsRoute },
                    RouteNames.ModelsRoute
                ));
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Model_Data_Mapping'),
                    { name: RouteNames.ModelDataMappingsRoute },
                    RouteNames.ModelDataMappingsRoute
                ));
            }
            else if (route == RouteNames.ModelDimensionSecurityRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute
                    ));
                    if (this.UserCanAccessModelSecurity) {
                        result.push(new BreadcrumbItem(
                            this.Localizer.Localize('Breadcrumb_Model_Dimension_Security'),
                            { name: RouteNames.ModelDimensionSecurityRoute },
                            RouteNames.ModelDimensionSecurityRoute
                        ));
                    }
                }
            }
            else if (route == RouteNames.DimensionHierarchyViewRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute
                    ));

                    const selectedDimension = this.$store.state.models.SelectedDimension as api.DimensionInfo | null;
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Dimensions'),
                        { name: RouteNames.DimensionViewRoute },
                        RouteNames.DimensionViewRoute
                    ));

                    if (selectedDimension != null) {
                        result.push(new BreadcrumbItem(
                            selectedDimension.dimensionName!,
                            { query: { selectedDimension: selectedDimension.dimensionName } },
                            `${RouteNames.DimensionHierarchyViewRoute}_${selectedDimension.dimensionName}`
                        ));
                        const selectedHierarchy = this.$store.state.models.SelectedHierarchy as string | null;
                        if (selectedHierarchy != null) {
                            result.push(new BreadcrumbItem(
                                selectedHierarchy,
                                { query: { selectedDimension: selectedDimension.dimensionName, selectedHierarchy } },
                                `${RouteNames.DimensionHierarchyViewRoute}_${selectedDimension.dimensionName}_${selectedHierarchy}`
                            ));
                        }
                    }
                }
            }
            else if (route == RouteNames.ModelViewEditorRoute) {
                if (this.UserCanAccessModels) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Metadata'),
                        { name: RouteNames.ModelsRoute },
                        RouteNames.ModelsRoute
                    ));

                    const selectedModelView = this.$store.state.models.SelectedModelView as api.ModelViewInfo | null;
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Model_ModelViews'),
                        { name: RouteNames.ModelViewsViewRoute },
                        RouteNames.ModelViewsViewRoute
                    ));

                    if (selectedModelView != null) {
                        result.push(new BreadcrumbItem(
                            selectedModelView.viewName!,
                            { query: { selectedDimension: selectedModelView.viewName } },
                            `${RouteNames.ModelViewEditorRoute}_${selectedModelView.viewName}`
                        ));
                    }
                }
            }
            else if (route == RouteNames.WorkflowRoute) {
                const path = this.$store.state.workflow.WorkflowPath;
                let hierarchy: api.FileSystemObjectContent[] | null = null;
                if (path != null) {
                    hierarchy = this.$store.getters['explorer/getFsoHierarchyByPath'](path);
                }
                if (hierarchy != null) {
                    for (let i = 0; i < hierarchy.length; i++) {
                        const myFso = hierarchy[i];
                        if (myFso.objectType == api.FileSystemType.Folder) {
                            result.push(new BreadcrumbItem(
                                i == 0 ? this.Localizer.Localize('Breadcrumb_Explorer') : myFso.name!,
                                { name: RouteNames.ExplorerRoute, query: { selectedFso: myFso.id.toString() } },
                                hierarchy[i]
                            ));
                        }
                    }
                }

                let id = null;
                if (this.$route.query['id'] != null) {
                    id = this.$route.query['id'];
                }
                const name = this.$store.state.workflow.WorkflowName;
                if (name != null) {
                    result.push(new BreadcrumbItem(
                        name!,
                        { name: route, query: { name, id, t: (Date.now()).toString() } },
                        'process'
                    ));
                }
                const subprocess = this.$store.state.workflow.CurrentSubprocessNodes as any[];
                if (subprocess != null && subprocess.length > 0) {
                    for (let i = 0; i < subprocess.length; i++) {
                        const actionName = subprocess[i].activity.name;
                        const t = Date.now();
                        result.push(new BreadcrumbItem(
                            actionName!,
                            { name: route, query: { name, id, subprocess: actionName, t: t.toString() } },
                            i + actionName
                        ));
                    }
                }
            }

            else if (route == RouteNames.ReportBookRoute) {
                const fso = this.$store.state.reportbook.ReportBook.fileSystemObject;
                const hierarchy: api.FileSystemObjectContent[] | null
                    = this.$store.getters['explorer/getFsoHierarchyByPath'](fso.path);
                if (hierarchy != null) {
                    for (let i = 0; i < hierarchy.length; i++) {
                        const myFso = hierarchy[i];
                        if (myFso.objectType == api.FileSystemType.Folder) {
                            result.push(new BreadcrumbItem(
                                i == 0 ? this.Localizer.Localize('Breadcrumb_Explorer') : myFso.name!,
                                { name: RouteNames.ExplorerRoute, query: { selectedFso: myFso.id.toString() } },
                                hierarchy[i]
                            ));
                        }
                    }
                }

                const name = fso.name;
                if (name) {
                    result.push(new BreadcrumbItem(
                        name,
                        { name: route, query: { id: fso.id } },
                        'reportbook'
                    ));
                }
            }

            else if (route == RouteNames.PowerBIRoute) {
                // @ts-ignore
                const reportPath = parseInt(this.$route.params.pathMatch);
                let fso;
                const hierarchy: api.FileSystemObjectContent[] | null
                    = this.$store.getters['explorer/getFsoHierarchyById'](reportPath);
                if (hierarchy != null) {
                    for (let i = 0; i < hierarchy.length; i++) {
                        const myFso = hierarchy[i];
                        if (myFso.objectType == api.FileSystemType.Folder) {
                            result.push(new BreadcrumbItem(
                                i == 0 ? this.Localizer.Localize('Breadcrumb_Explorer') : myFso.name!,
                                { name: RouteNames.ExplorerRoute, query: { selectedFso: myFso.id.toString() } },
                                hierarchy[i]
                            ));
                        }
                        else {
                            fso = myFso;
                        }
                    }
                }
                if (fso) {
                    const name = fso.name;
                    if (name) {
                        result.push(new BreadcrumbItem(
                            name,
                            { params: this.$route.params, name: route },
                            'report'
                        ));
                    }
                }
            }

            else if (route == RouteNames.WorkflowContributorRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Breadcrumb_Workflow_Contributor'),
                    { name: route },
                    route
                ));
            }

            else if (route == RouteNames.DashboardRoute) {
                const selectedSection = this.$store.state.dashboard.SelectedHomepage as api.DashboardSection | null;
                if (selectedSection) {
                    const localizedName = this.Localizer.ParseLocalizedString(selectedSection.name);
                    if (localizedName) {
                        result.push(new BreadcrumbItem(localizedName,
                            { name: route, query: this.$route.query }, localizedName));
                    }
                }
            }

            else if (route == RouteNames.DataHomepagesRoute) {
                if (this.UserCanAccessHomepages) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Configure'),
                        { name: RouteNames.DataRoute },
                        RouteNames.DataRoute
                    ));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Homepages_Homepages'),
                        { name: route },
                        route
                    ));
                }
            }

            else if (route == RouteNames.DataHomepageDesignerRoute) {
                if (this.UserCanAccessHomepages) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Breadcrumb_Configure'),
                        { name: RouteNames.DataRoute },
                        RouteNames.DataRoute
                    ));
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Homepages_Homepages'),
                        { name: RouteNames.DataHomepagesRoute },
                        route
                    ));
                    const selectedSection = this.$store.state.dashboard.SelectedHomepage as api.DashboardSection | null;
                    if (selectedSection) {
                        const localizedName = this.Localizer.ParseLocalizedString(selectedSection.name);
                        if (localizedName) {
                            result.push(new BreadcrumbItem(localizedName,
                                { name: route, query: this.$route.query }, localizedName));
                        }
                    }
                }
            }

            else if (route == RouteNames.JournalsRoute || route == RouteNames.JournalsEditRoute
                || route == RouteNames.JournalsSelectRoute || route == RouteNames.JournalsReportingRoute
                || route == RouteNames.JournalsAuditRoute || route == RouteNames.JournalsEditV2Route ) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('JournalsEdit_Journals'),
                    { name: RouteNames.JournalsSelectRoute },
                    RouteNames.JournalsSelectRoute
                ));
                if (route != RouteNames.JournalsSelectRoute) {                    
                    const journal = this.$store.state.journals.SelectedJournal as api.JournalDefinition | null;
                    if (journal) {
                        // Only call getJEFlag if isV2FlagEnabled is not already set
                        if (this.isV2FlagEnabled === false) {
                            this.getJEFlag();
                        }
                        const routeName = this.isV2FlagEnabled
                            ? RouteNames.JournalsEditV2Route
                            : RouteNames.JournalsEditRoute;
                        result.push(new BreadcrumbItem(
                            journal.name ?? '',
                            { name: routeName, query: { journal: journal.name } },
                            journal.name ?? ''
                        ));
                    }
                    if (route == RouteNames.JournalsReportingRoute) {
                        result.push(new BreadcrumbItem(
                            this.Localizer.Localize('JournalsEdit_Reporting'),
                            { name: RouteNames.JournalsReportingRoute },
                            route
                        ));
                    }
                    if (route == RouteNames.JournalsAuditRoute && journal) {                       
                        result.push(new BreadcrumbItem(
                            this.Localizer.Localize('JournalsEdit_JournalAuditSummary'),
                            { name: RouteNames.JournalsAuditRoute, query: { journal: journal.name }},
                            route
                        ));
                    }
                }
            }

            else if (route == RouteNames.MaintenanceTypeSelectorRoute) {
                result.push(new BreadcrumbItem(
                    this.Localizer.Localize('Sidebar_Maintenance'),
                    { name: RouteNames.MaintenanceRoute },
                    RouteNames.MaintenanceRoute
                ));
            }

            else if (route == RouteNames.MaintenanceFormListSelectorRoute) {
                if (this.UserCanAccessHomepages) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Sidebar_Maintenance'),
                        { name: RouteNames.MaintenanceRoute },
                        RouteNames.MaintenanceRoute
                    ));
                    const type = this.$store.state.maintenance.ListType as string;
                    if (type) {
                        result.push(new BreadcrumbItem(type, { name: route, query: this.$route.query }, type));

                    }
                }
            }

            else if (route == RouteNames.MaintenanceEditRoute) {
                if (this.UserCanAccessHomepages) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Sidebar_Maintenance'),
                        { name: RouteNames.MaintenanceRoute },
                        RouteNames.MaintenanceRoute
                    ));
                    const type = this.$store.state.maintenance.ListType as string;
                    if (type) {
                        result.push(new BreadcrumbItem(
                            type,
                            { name: RouteNames.MaintenanceFormListSelectorRoute },
                            type
                        ));
                    }
                    const form = this.$store.state.maintenance.HeaderForm as api.AdminForm;
                    if (form) {
                        result.push(new BreadcrumbItem(this.Localizer.ParseLocalizedString(form.displayName)!,
                            { name: route, query: this.$route.query }, this.Localizer.ParseLocalizedString(form.displayName)!));
                    }

                }
            }

            else if (route == RouteNames.CopyDimensionHierarchyDataRoute) {
                this.getCopyDataEnhancementsFlag();
                if (this.UserCanAccessHomepages && this.isCopyDataEnhancementsEnabled) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Sidebar_Maintenance'),
                        { name: RouteNames.MaintenanceRoute },
                        RouteNames.MaintenanceRoute
                    ));
                    const type = this.$store.state.maintenance.ListType as string;
                    if (type) {
                        result.push(new BreadcrumbItem(
                            type,
                            { name: RouteNames.MaintenanceFormListSelectorRoute },
                            type
                        ));
                    }
                    const form = this.$store.state.maintenance.HeaderForm as api.AdminForm;
                    if (form) {
                        result.push(new BreadcrumbItem(this.Localizer.ParseLocalizedString(form.displayName)!,
                            { name: route, query: this.$route.query }, this.Localizer.ParseLocalizedString(form.displayName)!));
                    } else {
                        const operationDisplayName = this.$route.query['operation'] as string;
                        if (operationDisplayName) {
                            const localizedName = this.Localizer.ParseLocalizedString(operationDisplayName)!;
                            result.push(new BreadcrumbItem(localizedName, { name: route, query: this.$route.query }, localizedName));
                        }
                    }                    
                }
            }

            else if (route == RouteNames.OwnershipChartRoute) {
                if (this.UserCanAccessHomepages) {
                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('Sidebar_Maintenance'),
                        { name: RouteNames.MaintenanceRoute },
                        RouteNames.MaintenanceRoute
                    ));

                    const type = this.$store.state.maintenance.ListType as string;
                    if (type) {
                        result.push(new BreadcrumbItem(
                            type,
                            { name: RouteNames.MaintenanceFormListSelectorRoute },
                            type
                        ));
                    }

                    const form = this.$store.state.maintenance.HeaderForm as api.AdminForm;
                    if (form) {
                        result.push(new BreadcrumbItem(
                            this.Localizer.ParseLocalizedString(form.displayName)!,
                            { name: RouteNames.MaintenanceEditRoute, query: { form: this.Localizer.ParseLocalizedString(form.displayName) } }, 
                            this.Localizer.ParseLocalizedString(form.displayName)!
                        ));
                    }

                    result.push(new BreadcrumbItem(
                        this.Localizer.Localize('OwnershipChartView_Breadcrumb_OrgChart'),
                        { name: route, query: this.$route.query }, 
                        RouteNames.OwnershipChartRoute
                    ));
                }
            }

            else if (route == RouteNames.HomeExtensionRoute) {
            var breadcrumbs = this.$store.state.HomeExtensionBreadcrumbs as uiIntegration.FluenceBreadcrumbMessage[];
                if (breadcrumbs) {
                    for (var i = 0; i < breadcrumbs.length; i++) {
                        var myBC = breadcrumbs[i];
                        result.push(new BreadcrumbItem(myBC.caption, { name: RouteNames.HomeExtensionRoute, query: myBC.params }, RouteNames.HomeExtensionRoute));
                    }
                }
            }

            return result;
        }

        get hideWhatsNew() {
            let hide = this.UserData == null || AuthClient.configuration.$config?.hideWhatsNew || !this.Tenant;
            return hide ?? false;
        }

        ChooseBackgroundSelected: boolean = false;
        TenantDropDownVisible: boolean = false; 
        showColorPickerMenu: boolean = false;
        colorPickerMenuStyle: any = { position: 'fixed', top: '40px', left: '10px', zIndex: 5000 };
        newVersionUpdatesAvailable: boolean = false;  
        private outsideClickHandler: EventListener | null = null;
        toggleTenantDropDown() {
            this.TenantDropDownVisible = !this.TenantDropDownVisible;
            if (!this.TenantDropDownVisible) {
                this.ChooseBackgroundSelected = false;
                this.showColorPickerMenu = false;
            }
        }

        closeTenantDropdown(event: MouseEvent) {
            const tenantContainer = (event.currentTarget as HTMLElement).querySelector('#tenant_v2') 
                || (event.currentTarget as HTMLElement).querySelector('#tenant');
            if (tenantContainer && !tenantContainer.contains(event.target as HTMLElement)) {
                this.TenantDropDownVisible = false;
                this.showColorPickerMenu = false;
                this.ChooseBackgroundSelected = false;
            }
        }

        private handleDocumentClick(event: Event) {
            const target = event.target as Node | null;
            if (!target) {
                return;
            }
            const tenantV2 = this.$refs?.tenantContainerV2 as HTMLElement | undefined;
            const tenantV1 = this.$refs?.tenantContainerV1 as HTMLElement | undefined;

            const clickedInsideTenantV2 = tenantV2 ? tenantV2.contains(target) : false;
            const clickedInsideTenantV1 = tenantV1 ? tenantV1.contains(target) : false;

            if (!clickedInsideTenantV2 && !clickedInsideTenantV1) {
                this.TenantDropDownVisible = false;
                this.showColorPickerMenu = false;
                this.ChooseBackgroundSelected = false;
            }
        }

        mounted() {
            this.outsideClickHandler = (event: Event) => this.handleDocumentClick(event);
            window.addEventListener('pointerdown', this.outsideClickHandler, true);
            document.addEventListener('click', this.outsideClickHandler, true);
        }

        unmounted() {
            if (this.outsideClickHandler) {
                window.removeEventListener('pointerdown', this.outsideClickHandler, true);
                document.removeEventListener('click', this.outsideClickHandler, true);
                this.outsideClickHandler = null;
            }
        }

        showReleaseNotes: boolean = false;
        async OpenReleaseNotes() {
            if (this.$store.state.whatsnew.Articles == null) {
                await this.$store.dispatch("whatsnew/GetArticles", true);
            }
            let notes = this.$store.state.whatsnew.Articles;
            if (notes == null || notes.length == 0) {
                this.showReleaseNotes = false;
            }
            else if (notes.length == 1) {
                if (notes[0].htmlText == null || notes[0].htmlText == "") {
                    this.showReleaseNotes = false;
                }
                else {
                    this.showReleaseNotes = true;
                }
            }
            else {
                this.showReleaseNotes = true;
            }
            this.newVersionUpdatesAvailable = false;
        }

        @Watch("UserData") async onUserDataLoad(val: api.UserData | undefined) {
            if (this.UserData != null) {
                let newVersion = this.UserData?.releaseInfo?.platform;
                let oldVersion = localStorage.getItem('whatsnewversion');

                if (!this.hideWhatsNew && (oldVersion == null || newVersion == null || oldVersion < newVersion)) {
                    this.newVersionUpdatesAvailable = true;
                    if (newVersion != null)
                        localStorage.setItem('whatsnewversion', newVersion);
                }
            }
        }

        BreadcrumbItem_Click(item: BreadcrumbItem) {
            const route = this.$route.name;
            const selectedFso = this.$store.state.explorer.SelectedFso as api.FileSystemObjectContent | null;
            if (selectedFso != null && selectedFso.id != null) {
                if (selectedFso !== item.payload) {
                    this.$store.commit('explorer/SelectFso', item.payload);
                }
            }
            const temp = item.location as any;
            if (route === RouteNames.ModelsRoute) {
                if (temp.query != null) {
                    if (temp.query.selectedHierarchy == null) {
                        this.$store.commit('models/SetSelectedHierarchy',
                            `(${this.Localizer.Localize('default_hierarchy_name')})`);
                    }
                }
                else {
                    this.$store.commit('models/SetSelectedDimension', null);

                }
            }
            else {
                this.$store.commit('models/SetSelectedHierarchy', null);
            }

            if (item.payload.id === RouteNames.MatchingUI) {
                PubSub.publish('breadcrumb.matching');
            }

            if (item.payload.id === RouteNames.DataJournalsRoute) {
                this.$store.commit('etl/SetSelectedJournalConfig', null);
            }

            this.$router.push(item.location);
        }

        goHome() {
            if (this.$store.state.security.UserData.hasDashboard) {
                this.$router.push({ name: RouteNames.DashboardRoute });
            }
            else {
                this.$router.push({ name: RouteNames.WorkflowContributorRoute });                
            }
        }

        chooseBackground() {
            this.ChooseBackgroundSelected = true;
        }

        async chooseBackgroundContinued(color: string) {
            var auth_client = base.AuthClient.getInstance();
            var client = new api.SecurityClient(auth_client);
            await client.setTenantBgColor(color);
            this.Tenant.bgColor = color;
        }

        // V2 Color selection methods (Modal-based)
        get ColorPalette(): ColorProp[] {
            return COLOR_PALETTE;
        }

        get DefaultTenantColor(): string {
            return DEFAULT_TENANT_COLOR;
        }

        getTenantIconColor(): string {
            return this.Tenant?.bgColor || DEFAULT_TENANT_COLOR;
        }

        openColorPickerMenu(event: MouseEvent) {
            this.showColorPickerMenu = true;
            // Position menu to the left of the click target
            const rect = (event.target as HTMLElement).getBoundingClientRect();
            this.colorPickerMenuStyle = {
                position: 'fixed',
                top: `${rect.top - 42}px`,
                left: `${rect.left - 249}px`,
                zIndex: 5000
            };
        }

        async onColorSelected(color: ColorProp) {
            var auth_client = base.AuthClient.getInstance();
            var client = new api.SecurityClient(auth_client);
            await client.setTenantBgColor(color.value);
            this.Tenant.bgColor = color.value;
            this.showColorPickerMenu = false;
        }

        async onResetColor(color: ColorProp) {
            var auth_client = base.AuthClient.getInstance();
            var client = new api.SecurityClient(auth_client);
            await client.setTenantBgColor(color.value);
            this.Tenant.bgColor = color.value;
            this.showColorPickerMenu = false;
        }

        private FormatTenantName(name: string, caption: string) {
            if (caption != null)
                return this.Localizer.ParseLocalizedString(caption);
            name = name.replaceAll("_", " ");
            if (name.length < 10 || name.indexOf(' ') > 0)
                return name;
            else {
                return name.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
            }
        }

        async switchTenant() {
            await this.$store.dispatch("security/LoadUserTenants");
            this.$router.push({ name: RouteNames.DashboardRoute});
            await this.$store.dispatch("CacheCleanup");
            this.$store.dispatch("contributor/ReLoadMyActivities");
        }

        setOverrideLang(item: { name: string, caption: string }) {

            if (item.name == "Import File") {
                this.toggleTranslationtDropDown(false);
                const loadLanguageFile: HTMLElement | null = document.getElementById("loadLanguageFile");
                loadLanguageFile!.click();
                return;
            }
            else if (item.name == "Export File") {
                this.toggleTranslationtDropDown(false);

                var locales = this.$store.state.Locale;
                const data = JSON.stringify(locales);
                const blob = new Blob([data], { type: 'text/plain' })
                const e = document.createEvent('MouseEvents'),
                    a = document.createElement('a');
                a.download = localStorage.getItem("UserLocaleOverride") + ".json";
                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                e.initEvent('click', true, false);
                a.dispatchEvent(e);

                return;
            }
            else {
                Localizer.DebugMode = (item.name == "Debug");

                this.$store.dispatch("SetLocalizationLanguage", item.name);
                if (item.name != "Debug")
                    localStorage.setItem("UserLocaleOverride", item.name);
            }
            let c_event = new CustomEvent("langOverrideRefresh");
            dispatchEvent(c_event);

            this.toggleTranslationtDropDown(false);
        }

        localeLangs() {
            if (this.cachedLocaleLangs == null) {
                if (typeof languages[0] === "string") {
                    let langs = languages.map((x: any) => {
                        return {
                            name: x as string,
                            caption: (x as string).toUpperCase()
                        }
                    });

                    this.cachedLocaleLangs = langs
                }
                let temp = languages.sort((a: any, b: any) => {
                    if (a.name.toUpperCase() == "EN")
                        return -1;
                    if (b.name.toUpperCase() == "EN")
                        return 1;
                    return a.name.localeCompare(b.caption);
                }).map(x => x);
                this.cachedLocaleLangs = temp;
            }
            let result = [...this.cachedLocaleLangs]
            if (this.FeatureFlagLocalesDebug) {
                result.push({ name: 'Debug', caption: 'Debug' });
                result.push({ name: 'Import File', caption: 'Import File' });
                result.push({ name: 'Export File', caption: 'Export File' });
            }

            return result;
        }

        LoadCustomLanguage(event: any) {
            const files = event.target.files
            let filename = files[0].name
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.$store.dispatch("SetCustomLocalizationLanguage", fileReader.result);
                let c_event = new CustomEvent("langOverrideRefresh");
                dispatchEvent(c_event);
            })
            fileReader.readAsText(files[0]);
        }
        private async getJEFlag(){
            var auth_client = base.AuthClient.getInstance();
            var client = new api.JournalClient(auth_client);
            this.isV2FlagEnabled = await client.getJEFeatureFlag();
        }
        private async getCopyDataEnhancementsFlag(){
            this.isCopyDataEnhancementsEnabled = await isFeatureFlagEnabled("CONS-178-CopyDataEnhancements");
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #tenant {
        float: right;
        text-align: center;
        background-color:  #242D48 !important;
        color: var(--accent-foreground);
        font-weight: normal;
    }

    #tenant_v2 {
        float: right;
        text-align: center;
        color:  #242D48 !important;
        font-weight: normal;
        position: relative;
    }

    .languages {
        cursor: pointer;
        float: right;
        text-align: center;
        padding: 0 16px;
    }

    .whatsnew {
        float: right;
        cursor: pointer;
    }

    .no-outline {
        outline: none;
    }

    .headerbtnmain {
    cursor: pointer;
    padding-right: 10px;
    padding-left: 10px;
    line-height: 38.5px;
    min-width:150px;
}
    .headerbtnmain:hover {
        background: rgba(255, 255, 255, 0.16);
    }

    .headermodal-enter-active, .headermodal-leave-active {
        transition: all .3s ease;
    }

    .headermodal-enter-from, .headermodal-leave-to {
        transform: translateY(10px);
        opacity: 0;
    }

    .tenantmodal {
        color: #555555;
        background-color: #FFFFFF;
        box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.25);
        border-radius: 4px;
        position: fixed;
        right: 7px;
        z-index: 4000;
        text-align: left;
        width: 190px;
    }

    .headerbtn {
        cursor: pointer;
        padding-right: 10px;
        padding-left: 10px;
        line-height: 40px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: start;
    }

    .headerbtn:hover {
        background-color: var(--header-btn-hover);
    }

    .swatch {
        width: 42px;
        height: 42px;
        border-radius: 11px;
        cursor: pointer;
        margin: 5px 5px 5px 5px;
        display: inline-block;       
    }

    /* New V2 Tenant Color Styling */
    .tenant-divider {
        position: absolute;
        left: 1px;
        top: 7px;
        bottom: 10px;
        width: 1px;
        background-color: var(--thin-border);
        opacity: 0.7;
    }
    .tenant-section {
        display: inline-flex;
        align-items: center;
        position: relative; /* Needed for pseudo-element positioning */
        transition: all 0.3s ease;
        padding-bottom: 4px;
        width: auto;
        max-width: fit-content;
    }

    .tenant-section::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
        top: 36px;
        background-color: var(--line-color, transparent);
        transition: background-color 0.3s ease;
    }

    .cloud-icon {
        transition: all 0.3s ease;
        width: 21px;
        height: 21px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 6px; 
    }

    .tenant-name {
        transition: all 0.3s ease;
        margin-right: 6px; /* Match icon spacing */
        white-space: nowrap;
    }

    .dividing-line {
        height: 1px;
        background-color: #E6E6E6;
        margin: 0;
    }

    .reset-icon {
        color: #666;
        cursor: pointer;
        margin-left: auto;
        padding: 2px;
    }

    .color-tool-container {
        padding: 10px;
        background-color: #f9f9f9;
        border-top: 1px solid #e6e6e6;
    }

    .color-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;
        max-width: 160px;
    }

    .color-swatch {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        cursor: pointer;
        border: 2px solid transparent;
        transition: all 0.2s ease;
        position: relative;
    }

    .color-swatch:hover {
        border-color: #333;
        transform: scale(1.1);
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    }

    .color-swatch:active {
        transform: scale(0.95);
    }

    .curtain {
        position: fixed;
        z-index: 3000;
        top: 86px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: var(--background-curtain);
    }

    .curtain-enter-active, .curtain-leave-active {
        transition: opacity .3s;
    }

    .curtain-enter-from, .curtain-leave-to {
        opacity: 0;
    }

    #breadcrumb {
        height: 40px;
        line-height: 40px;
        background-color: var(--background-breadcrumb);
        color: var(--foreground-breadcrumb);
        border-bottom: 1px solid var(--thin-border);
        border-top: 1px solid var(--thin-border);
        font-weight: bold;
        padding-left: 14px;
        width: 100%;
        position: absolute;
        top: 46px;
        right: 0;
        left: 0;
        z-index: 100;
    }

    .breadcrumb-homeV2-svg{
        width: 16px;
        height: 16px;
    }

    .arrowLeft {
        content: url("../../public/icons/arrow_right.svg");
        padding: 6px;
    }

    .breadcrumb-button {
        cursor: pointer;
    }

    .fso-leave-active {
    }

    .fso-enter-active {
        transition: all .3s ease;
        transition-delay: calc(.08s * var(--i));
    }

    .fso-enter-from, .fso-leave-to {
        opacity: 0;
    }
</style>
